import { useEffect, useRef, useState } from 'react';

export const useHasVerticalScroll = <T extends HTMLElement>() => {
  const ref = useRef<T | null>(null);
  const [hasScroll, setHasScroll] = useState(false);

  useEffect(() => {
    const checkScroll = () => {
      if (!ref.current) {
        return;
      }
      setHasScroll(ref.current.scrollHeight > ref.current.clientHeight);
    };

    checkScroll(); // Initial check

    const observer = new ResizeObserver(checkScroll);
    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, []);

  return { ref, hasScroll };
};
